import { Box, Stack, Typography } from '@mui/material';

export const BAR_COLOR = '#DAA335';

const NUM_SX = { fontFeatureSettings: '"lnum" 1, "tnum" 1' };

type BarCellProps = {
  /** Formatted value */
  label: string;
  value: number;
  /** Max of the column on the displayed rows: the bar length is value / max. */
  max: number;
  /** Optional right-hand parts: share (%) and evolution. */
  share?: string;
  evolution?: React.ReactNode;
  showBar?: boolean;
};

/** Value + golden bar (+ share and evolution), as in the maquette. */
export default function BarCell({ label, value, max, share, evolution, showBar = true }: BarCellProps) {
  const ratio = max > 0 ? Math.max(0, Math.min(1, value / max)) : 0;
  return (
    <Stack direction="row" alignItems="center" spacing={1} sx={{ width: 1, minWidth: 0 }}>
      <Typography sx={{ fontSize: 14, lineHeight: '22px', color: '#2F3843', whiteSpace: 'nowrap', ...NUM_SX }}>{label}</Typography>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        {showBar && ratio > 0 && (
          <Box data-testid="bar" sx={{ height: 6, width: `${ratio * 100}%`, bgcolor: BAR_COLOR, borderRadius: '8px' }} />
        )}
      </Box>
      {share !== undefined && (
        <Typography sx={{ fontSize: 13, lineHeight: '22px', color: '#637381', textAlign: 'right', minWidth: 36, ...NUM_SX }}>
          {share}
        </Typography>
      )}
      {evolution}
    </Stack>
  );
}
